export default {
  techTheirWayTitle: {
    id: 'gift_cards_reassurance_items_tech_their_way_title',
    defaultMessage: 'Tech their way',
  },
  techTheirWaySubtitle: {
    id: 'gift_cards_reassurance_items_tech_their_way_subtitle',
    defaultMessage: 'With a single-use code to use at checkout.',
  },
  doesNotExpireTitle: {
    id: 'gift_cards_reassurance_items_does_not_expire_title',
    defaultMessage: 'Doesn’t expire',
  },
  doesNotExpireSubtitle: {
    id: 'gift_cards_reassurance_items_does_not_expire_subtitle',
    defaultMessage: 'Plenty of time to choose.',
  },
  sixMonthsValidityPeriodTitle: {
    id: 'gift_cards_reassurance_items_six_months_validity_period_title',
    defaultMessage: 'Good for 6 months',
  },
  sixMonthsValidityPeriodSubtitle: {
    id: 'gift_cards_reassurance_items_six_months_validity_period_subtitle',
    defaultMessage: 'And a wide range of refurbished tech to choose from.',
  },
  faqTitle: {
    id: 'gift_cards_reassurance_items_faq_title',
    defaultMessage: 'See how gift cards work',
  },
  faqSubtitle: {
    id: 'gift_cards_reassurance_items_faq_subtitle',
    defaultMessage: 'Read our FAQ’s.',
  },
}
